import React, { useEffect, useState } from "react";
import Tree from "../../components/SideBar/Tree";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { useTreeContext } from "../../context/TreeDataContext";
import { useNavigate, useParams } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import Button from "../../components/FormComponents/Button";
import BuilderTabs from "../BuilderTabs";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import {
  getTreeDataForApplicationBlock,
  getTreeDataForEntity,
  getTreeDataForForm,
  getTreeDataForScreens,
  getTreeDataForStateMachine,
  getTreeDataForWorkflow
} from "../../utils/treeData/treeDataUtils";

const AppBlueprintTrees = ({ setIsModalOpen }) => {
  const {
    screensExplorerData,
    setScreensExplorerData,
    entityExplorerData,
    setEntityExplorerData,
    workflowExplorerData,
    setWorkflowExplorerData,
    stateMachineExplorerData,
    setStateMachineExplorerData,
    blocksExplorerData,
    setBlocksExplorerData,
    formsExplorerData,
    setFormsExplorerData
  } = useTreeContext();
  const [screenData, setScreenData] = useState([]);
  const [entityData, setEntityData] = useState([]);
  // const [wordkflowData, setWordkflowData] = useState([]);
  const [statemachineData, setStatemachineData] = useState([]);
  const [formData, setFormData] = useState([]);
  const [blocksData, setBlocksData] = useState([]);
  const navigate = useNavigate();
  const { orgId, appId } = useParams();

  const settingAllTreeData = async () => {
    try {
      if (!screensExplorerData) {
        const { data } = await axiosInstance.get(`/screens`);
        const treeData = getTreeDataForScreens(data);
        setScreensExplorerData(treeData);
        setScreenData(treeData);
      } else {
        setScreenData(screensExplorerData);
      }
      if (!entityExplorerData) {
        const { data } = await axiosInstance.get(`/entity`);
        const treeData = getTreeDataForEntity(data);
        setEntityExplorerData(treeData);
        setEntityData(treeData);
      } else {
        setEntityData(entityExplorerData);
      }
      if (!workflowExplorerData) {
        const { data } = await axiosInstance.get("/workflow");
        const treeData = getTreeDataForWorkflow(data);
        setWorkflowExplorerData(treeData);
        // setWordkflowData(treeData);
      } else {
        // setWordkflowData(workflowExplorerData);
      }
      if (!stateMachineExplorerData) {
        const { data } = await axiosInstance.get(`/state-machines`);
        const treeData = getTreeDataForStateMachine("all", data, { delete: false, insert: false });
        setStateMachineExplorerData(treeData);
        setStatemachineData(treeData);
      } else {
        setStatemachineData(stateMachineExplorerData);
      }
      if (!formsExplorerData) {
        const { data } = await axiosInstance.get(`/state-machines/activities`);
        const { data: customFunctionData } = await axiosInstance.get(`/custom_function`);
        const { data: subFormData } = await axiosInstance.get(`/subform`);
        const treeData = getTreeDataForForm({ ...data, custom_function: customFunctionData, subform: subFormData });
        setFormsExplorerData(treeData);
        setFormData(treeData);
      } else {
        setFormData(formsExplorerData);
      }
      if (!blocksExplorerData) {
        const res = await Promise.all([
          axiosInstance.get(`/recordsview`),
          axiosInstance.get(`/detailsview`),
          axiosInstance.get(`/chart`),
          axiosInstance.get(`/mapsview`),
          axiosInstance.get(`/activitycard`),
          axiosInstance.get(`/calendar`),
          axiosInstance.get(`/kanban`),
          axiosInstance.get(`/progress-bar`)
        ]);
        const recordsViewData = res[0].data;
        const detailsViewData = res[1].data;
        const chartData = res[2].data;
        const mapsViewData = res[3].data;
        const activityCardData = res[4].data;
        const calenderData = res[5].data;
        const kanbanData = res[6].data;
        const progressBarData = res[7].data;

        const treeData = getTreeDataForApplicationBlock(
          [
            recordsViewData,
            detailsViewData,
            chartData,
            mapsViewData,
            activityCardData,
            calenderData,
            kanbanData,
            progressBarData
          ],
          { delete: false, insert: false }
        );
        setBlocksExplorerData(treeData);
        setBlocksData(treeData);
      } else {
        setBlocksData(blocksExplorerData);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const getPageEndPoint = (type) => {
    switch (type) {
      case "desktop":
      case "mobile":
      case "screen":
        return "screen";
      case "entity":
        return "entity";
      case "workflow":
        return "workflow";
      case "states":
      case "activities":
        return "statemachine";
      case "entities":
      case "statemachine":
        return "form";
      case "recordsview":
      case "detailsview":
      case "chart":
        return "applicationblock";
      default:
        return false;
    }
  };
  const [showPopup, setShowPopup] = useState(false);
  const [folderItems, setFolderItems] = useState([]);

  const handleScreens = (folder) => {
    setFolderItems(folder.items);
    setShowPopup(true);
  };

  const handleForms = (folder) => {
    setFolderItems(folder.items);
    setShowPopup(true);
  };

  const handleStatemachine = (folder) => {
    const items = folder.items || [];
    setFolderItems(items);

    const shouldShowPopup = items.some((item) => {
      const pd = item?.parentData || "";
      return pd.includes("states") || pd.includes("activities");
    });

    if (shouldShowPopup) {
      setShowPopup(true);
    }
  };

  const handleApplicationBlock = (folder) => {
    setFolderItems(folder.items);
    setShowPopup(true);
  };

  const handleItemReorder = (newItems) => {
    setFolderItems(newItems);
  };

  const handleSaveScreens = async () => {
    // Update Desktop Screen Data
    const allIDs = folderItems.map((folderItem) => folderItem.id);
    // return
    await axiosInstance.put(`/order/screen/${folderItems[0].parentData}`, {
      IDs: allIDs
    });
    const updatedScreenData = updateScreenData(folderItems);
    setScreensExplorerData(updatedScreenData);
    // Update state with the updated desktop screen data

    setScreenData(updatedScreenData);
  };

  const handleSaveStateMachine = async (folderItems) => {
    try {
      const allIDs = folderItems.map((folderItem) => folderItem.id);
      const smData = folderItems[0].parentData.split("/");
      const statemachineIdToUpdate = folderItems.length > 0 ? smData[0] : null;
      // /order/:id/:type
      if (statemachineIdToUpdate) {
        await axiosInstance.put(`/order/state-machine/${statemachineIdToUpdate}/${smData[1]}`, {
          IDs: allIDs
        });
        // Update State Machine Data
        updateStateMachineData(statemachineIdToUpdate, folderItems);
      }
    } catch (error) {
      handleApiError(error);
    }

    setShowPopup(false);
  };

  const handleSaveFormsEntity = () => {
    // Update entity data
    const updatedEntityData = updateFormEntityData();

    // Update state with the updated entity data
    setFormData(updatedEntityData);

    setShowPopup(false);
  };

  const handleSaveFormsStatemachine = () => {
    // Determine the folder ID dynamically based on the first item in folderItems
    const folderIdToUpdate = folderItems.length > 0 ? folderItems[0].parentData.split("/")[0] : null;

    if (folderIdToUpdate) {
      // Update form state machine data with the dynamically determined folder ID
      const updatedFormData = updateFormStatemachineData(folderIdToUpdate);

      // Update state with the updated form data
      setFormData(updatedFormData);
    }
  };

  const handleSaveApplicationBlocks = async () => {
    // Update application blocks data
    try {
      const data = folderItems[0].parentData.split("/");
      const allIDs = folderItems.map((folderItem) => folderItem.id);
      // return
      await axiosInstance.put(`/order/block/${data[0]}/${data[1]}`, {
        IDs: allIDs
      });
      const updatedBlocksData = updateApplicationBlocksData(folderItems);

      // Update state with the updated application blocks data
      setBlocksExplorerData(updatedBlocksData);
      setBlocksData(updatedBlocksData);
    } catch (error) {
      handleApiError(error);
    }

    setShowPopup(false);
  };

  const handleSave = async () => {
    if (showPopup) {
      // Check if folderItems contain items for desktop or mobile screens
      const hasDesktopItems = folderItems.some((item) => item.parentData === "desktop");
      const hasMobileItems = folderItems.some((item) => item.parentData === "mobile");
      const hasFormEntityItems = folderItems.some((item) => item.parentData.includes("entities"));
      const hasFormStatemachineItems = folderItems.some((item) => item.parentData.includes("statemachine"));
      const hasApplicationBlockItems = folderItems.some(
        (item) => item.parentData.startsWith("desktop") || item.parentData.startsWith("mobile")
      );
      if (hasDesktopItems || hasMobileItems) {
        await handleSaveScreens();
      } else if (hasFormEntityItems) {
        handleSaveFormsEntity();
      } else if (hasFormStatemachineItems) {
        handleSaveFormsStatemachine();
      } else if (hasApplicationBlockItems) {
        await handleSaveApplicationBlocks();
      } else {
        const statemachineIdToUpdate = folderItems.length > 0 ? folderItems[0].parentData.split("/")[0] : null;
        if (statemachineIdToUpdate) {
          await handleSaveStateMachine(folderItems, statemachineIdToUpdate);
        }
      }

      // Update state machine data

      setShowPopup(false);
    }
  };

  const updateScreenData = () => {
    return screenData.map((screen) => {
      if (screen.name === folderItems[0].parentData) {
        const filteredItems = folderItems.filter((item) => item.parentData === folderItems[0].parentData);
        return {
          ...screen,
          items: filteredItems
        };
      }
      return screen;
    });
  };

  const updateStateMachineData = (statemachineIdToUpdate, folderItems) => {
    const updatedStatemachineData = statemachineData.map((statemachine) => {
      if (statemachine.id === statemachineIdToUpdate) {
        const statesToUpdate = statemachine.items.find((item) => item.name === "states");
        const activitiesToUpdate = statemachine.items.find((item) => item.name === "activities");

        if (!statesToUpdate || !activitiesToUpdate) {
          return statemachine; // Skip if states or activities not found
        }

        let reorderedStatesItems, reorderedActivitiesItems;
        if (folderItems && folderItems.length > 0) {
          if (folderItems[0].parentData.includes("states")) {
            reorderedStatesItems = folderItems
              .map((folderItem) => {
                const correspondingItem = statesToUpdate.items.find((item) => item.id === folderItem.id);
                return correspondingItem;
              })
              .filter(Boolean);
          } else if (folderItems[0].parentData.includes("activities")) {
            reorderedActivitiesItems = folderItems
              .map((folderItem) => {
                const correspondingItem = activitiesToUpdate.items.find((item) => item.id === folderItem.id);
                return correspondingItem;
              })
              .filter(Boolean);
          }
        }

        // Create a new state machine object with updated items
        return {
          ...statemachine,
          items: statemachine.items.map((item) => {
            if (item.name === "states") {
              return {
                ...item,
                items: reorderedStatesItems || item.items
              };
            } else if (item.name === "activities") {
              return {
                ...item,
                items: reorderedActivitiesItems || item.items
              };
            }
            return item;
          })
        };
      }
      return statemachine;
    });

    // Update the state with the new array
    setStatemachineData(updatedStatemachineData);
    setStateMachineExplorerData(updatedStatemachineData);
  };

  const updateFormEntityData = () => {
    return formData.map((form) => {
      // Check if the form is for entities
      if (form.name === "entities") {
        // Filter out items that belong to this form
        const filteredItems = folderItems.filter((folderItem) => folderItem.parentData.includes(form.name));
        // Update the items array of the form with the filtered items
        return {
          ...form,
          items: filteredItems
        };
      }
      return form;
    });
  };

  const updateFormStatemachineData = (folderIdToUpdate) => {
    const updatedFormData = JSON.parse(JSON.stringify(formData));

    updatedFormData.forEach((form) => {
      if (form.name === "statemachine" && Array.isArray(form.items)) {
        form.items.forEach((folder) => {
          const folderId = folder.id;
          if (folder.isFolder && folderId === folderIdToUpdate && Array.isArray(folder.items)) {
            const relevantFolderItems = folderItems.filter((item) =>
              item.parentData.startsWith(`${folderId}/statemachine`)
            );

            const copiedRelevantFolderItems = JSON.parse(JSON.stringify(relevantFolderItems));

            folder.items = [...copiedRelevantFolderItems];
          }
        });
      }
    });

    return updatedFormData;
  };

  const updateApplicationBlocksData = (folderItems) => {
    return blocksData.map((block) => {
      // Check if the block is desktop or mobile
      if (block.name === "desktop" || block.name === "mobile") {
        // Create a map to store reordered items for each parentData
        const reorderedItemsMap = {};
        // Iterate through the folderItems and populate the map
        folderItems.forEach((folderItem) => {
          const parentData = folderItem.parentData;
          if (!reorderedItemsMap[parentData]) {
            reorderedItemsMap[parentData] = [];
          }
          reorderedItemsMap[parentData].push(folderItem);
        });
        // Iterate through each item in the block
        const updatedItems = block.items.map((item) => {
          const parentData = `${block.name}/${item.name}`;
          // If there are reordered items for the current parentData, update the items array
          if (reorderedItemsMap[parentData]) {
            return {
              ...item,
              items: reorderedItemsMap[parentData]
            };
          }
          // If no reordered items found, keep the original items intact
          return item;
        });
        // Return the block with updated items
        return {
          ...block,
          items: updatedItems
        };
      }
      return block;
    });
  };

  const callbackFunction = (id, parentData) => {
    const typesArray = parentData.split("/");
    const type = typesArray[typesArray.length - 1];
    const endPoint = getPageEndPoint(type);
    navigate(`/organization/${orgId}/app/${appId}/${endPoint}/${id}`);
    // organization/652ccae165c064130608468e/app/6530e371ff2a410478f4881b/workflow/65360a6a99b3af4937e662de
    setIsModalOpen(false);
  };

  useEffect(() => {
    settingAllTreeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h_75_vh w_70_vw">
      {!showPopup ? (
        <div className="blue_print_popup_outer">
          <div className="blueprints_data">
            <BuilderTabs
              tabs={[
                {
                  label: `Entities (${entityData ? entityData.length : 0})`,
                  content: (
                    <div className="blueprint_popup_folder_item">
                      <label className="builder_label blueprint_popup_folder_title">Entities</label>
                      {entityData && entityData.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "15px" }}>
                          <Tree
                            explorerData={entityData}
                            setExplorerData={setEntityData}
                            folderData={entityData}
                            // actionNeeded={false}
                            callbackFunction={callbackFunction}
                            isBlueprint={true}
                          />
                        </div>
                      ) : (
                        <p>No entity data available</p>
                      )}
                    </div>
                  )
                },
                {
                  label: `Screens (${screenData ? screenData.reduce((total, screen) => total + (screen.items ? screen.items.length : 0) + (screen.items ? screen.items.reduce((nestedTotal, nested) => nestedTotal + (nested.items ? nested.items.length : 0), 0) : 0), 0) : 0})`,
                  content: (
                    <div className="blueprint_popup_folder_item">
                      <label className="builder_label blueprint_popup_folder_title">Screens</label>
                      <div className="d_flex">
                        <Tree
                          explorerData={screenData}
                          setExplorerData={setScreenData}
                          folderData={screenData}
                          // actionNeeded={false}
                          callbackFunctionForFolder={handleScreens}
                          callbackFunction={callbackFunction}
                          // screenData={setScreenData}
                          isBlueprint={true}
                        />
                      </div>
                    </div>
                  )
                },
                {
                  label: `SM-Workflow (${statemachineData ? statemachineData.filter((item) => item.type === "default").length : 0})`,
                  content: (
                    <div className="blueprint_popup_folder_item">
                      <label className="builder_label blueprint_popup_folder_title">State-machine</label>
                      <div className="d_flex">
                        <Tree
                          explorerData={statemachineData}
                          setExplorerData={setStatemachineData}
                          folderData={statemachineData}
                          // actionNeeded={false}
                          callbackFunction={callbackFunction}
                          callbackFunctionForFolder={handleStatemachine}
                          isBlueprint={true}
                          // statemachineData={setStatemachineData}
                        />
                      </div>
                    </div>
                  )
                },
                {
                  label: `Forms (${formData.reduce((total, folder) => {
                    if (folder.isFolder && folder.isOpen) {
                      const countNestedItems = (items) => {
                        return items.reduce((count, item) => {
                          if (item.isFolder) {
                            return count + countNestedItems(item.items);
                          }
                          return count + 1;
                        }, 0);
                      };
                      return total + countNestedItems(folder.items);
                    }
                    return total;
                  }, 0)})`,
                  content: (
                    <div className="blueprint_popup_folder_item">
                      <label className="builder_label blueprint_popup_folder_title">Forms</label>
                      <div className="d_flex">
                        <Tree
                          explorerData={formData}
                          setExplorerData={setFormData}
                          folderData={formData}
                          actionNeeded={false}
                          callbackFunctionForFolder={handleForms}
                          callbackFunction={callbackFunction}
                          isBlueprint={true}
                        />
                      </div>
                    </div>
                  )
                },
                {
                  label: `Application Blocks (${
                    blocksData
                      ? blocksData.reduce((total, block) => {
                          const countItems = (data) =>
                            data.reduce((sum, item) => sum + (item.isFolder ? countItems(item.items || []) : 1), 0);
                          return total + countItems([block]);
                        }, 0)
                      : 0
                  })`,
                  content: (
                    <div className="blueprint_popup_folder_item border_none">
                      <label className="builder_label blueprint_popup_folder_title">Application Blocks</label>
                      <div className="d_flex">
                        <Tree
                          explorerData={blocksData}
                          setExplorerData={setBlocksData}
                          folderData={blocksData}
                          // actionNeeded={false}
                          callbackFunctionForFolder={handleApplicationBlock}
                          callbackFunction={callbackFunction}
                          isBlueprint={true}
                        />
                      </div>
                    </div>
                  )
                }
              ]}
            />
            {/* </div> */}
          </div>
        </div>
      ) : (
        <div className="app_bluePrint_popup_body">
          <div className="cursor_pointer position_absolute top_0 left_0" onClick={() => setShowPopup(false)}>
            <MaterialIcon name="arrow_back" />
          </div>
          <div className="app_bluePrint_draggable_outer">
            <div>
              <ReactSortable list={folderItems} setList={handleItemReorder} animation={200} easing="ease-out">
                {folderItems.map((item) => (
                  <div key={item.id}>
                    <MaterialIcon name="drag_indicator" className="Recordsviewfielddragclass font_size_large" />
                    {item.name}
                  </div>
                ))}
              </ReactSortable>
            </div>
            <div className="d_flex gap_5">
              <Button variant="secondary" onClick={() => setShowPopup(false)}>
                back
              </Button>
              <Button onClick={handleSave}>Save</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppBlueprintTrees;
